import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';
import Button from '../../../shared/components/atoms/button/button';
import useMobile from '../../../shared/hooks/useMobile';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './guideline-products.scss';

const GuidelineProducts = ({ guideline }) => {

    const mobile = useMobile();
    const { homeLink } = useHomeLinkMode();

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-a-GuidelineProducts-description">{next}</p>
        }
    };


    return (
        <div className="f-a-GuidelineProducts">
            <div className="f-a-GuidelineProducts__content">
                <div className="f-a-GuidelineProducts__image-container">
                    <GatsbyImage
                        image={guideline.imagenesAutopautas[0].gatsbyImageData}
                        alt={guideline.imagenesAutopautas[0].description}
                        className="f-a-GuidelineProducts__image"
                    />
                </div>
                <div className="f-a-GuidelineProducts__info">
                    <div className="f-a-GuidelineProducts__title">{guideline.tituloAutopauta}</div>
                    {guideline.descripcionAutopauta.raw && documentToReactComponents(JSON.parse(guideline.descripcionAutopauta.raw), options)}
                    {mobile ?
                        <Button
                            className="f-a-button__primary-blue f-a-button__big f-a-GuidelineProducts__button"
                            copy={guideline.ctaAutopauta}
                            onclick={() => { location.href = homeLink + guideline.ctaRedireccionAutopauta }}
                        />
                        :
                        <Button
                            className="f-a-button__primary-blue f-a-button__medium f-a-GuidelineProducts__button"
                            copy={guideline.ctaAutopauta}
                            onclick={() => { location.href = homeLink + guideline.ctaRedireccionAutopauta }}
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default GuidelineProducts